import { motion, Transition } from 'framer-motion'

const dotTransition: Transition = {
  duration: 0.3,
  repeat: Infinity,
  repeatDelay: 0.5,
  ease: 'easeInOut'
}

const EllipsisAnimation = () => {
  return (
    <motion.div className="flex flex-row">
      <motion.span animate={{ scale: [1, 1.2, 1] }} transition={dotTransition}>
        .
      </motion.span>
      <motion.span
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ ...dotTransition, delay: 0.2 }}
      >
        .
      </motion.span>
      <motion.span
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ ...dotTransition, delay: 0.4 }}
      >
        .
      </motion.span>
    </motion.div>
  )
}

export default EllipsisAnimation
